import React from 'react'
import { withIcon } from '../../withIcon'

function ThumbsUpIcon (props) {
  const {
    size = '16px',
    color = 'currentColor',
    filled = false,
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M4.5 7L7.2 2.6C7.4 2.3 7.7 2 8.1 2C8.9 2 9.5 2.6 9.5 3.4V6H12.6C13.4 6 14 6.8 13.8 7.6L12.6 12.6C12.4 13.4 11.7 14 10.9 14H6.5C6 14 5.5 13.8 5.1 13.4L4.5 12.8V7Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={filled ? color : 'none'} />
      <path d="M2 7H4V14H2V7Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={filled ? color : 'none'} />
    </svg>
  )
}

export default withIcon(ThumbsUpIcon)
